import React from 'react'
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import moment from 'moment'

import './index.css'
import { AiOutlineFile, AiOutlineDownload } from 'react-icons/ai';
import client from '../../../services/Api';


const customStyles = {
  rows: {
    style: {
      '&:hover': {
        backgroundColor: '#03989E',
        color: 'white',
        transition: '.2s'
      },
    }
  },
};

export default function FirmwareTable({ firmwares, callbackNotes }) {
  const data = firmwares

  //datatable config
  const columns = [
    {
      name: 'Versão',
      selector: 'version',
      sortable: false,
      width: '25%',
    },
    {
      name: 'Data da Atualização',
      format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
      selector: 'created_at',
      sortable: true,
      width: '30%',
    },
    {
      name: '',
      cell: (row) =>
        <div className='action-buttons'>
          <button className="edit-firmware" onClick={() =>
            window.location.href = `${client.defaults.baseURL}/api/firmwares/${row._id}/download`
          }>
            Baixar Arquivo
              <AiOutlineDownload size='1.5rem' />
          </button>

          <button className="notes-firmware" onClick={() =>
            callbackNotes(row)
          }>
            Ver Notas
              <AiOutlineFile size='1.5rem' />
          </button>
        </div>
      ,
      width: '37%',
      right: true,
      print: false,
      export: false
    },
  ];

  const tableData = {
    data,
    columns
  };

  return (
    <div className='FirmwareTable'>
      <DataTableExtensions
        {...tableData}
        filterPlaceholder="Pesquisar versões"
        print={false}
        exportHeaders={true}>
        <DataTable
          responsive
          columns={columns}
          data={data}
          noDataComponent={
            <span>Nenhum versão registrada</span>
          }
          pagination={true}
          customStyles={customStyles}
        />
      </DataTableExtensions>
    </div>
  )
}
